interface MetaPhaseLinkProps {
  className?: string
}

/**
 * Always render "MetaPhase" the same way: bold, accent-colored, external
 * link to metaphase.tech. Used in the gov banner, footer, and anywhere
 * else we name the company.
 */
export function MetaPhaseLink({ className = '' }: MetaPhaseLinkProps) {
  return (
    <a
      href="https://metaphase.tech"
      target="_blank"
      rel="noopener noreferrer"
      className={[
        'font-semibold text-[var(--color-metaphase)] hover:text-[var(--color-metaphase-hover)] hover:underline underline-offset-2',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-metaphase)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--color-surface)] rounded',
        className,
      ].join(' ')}
    >
      MetaPhase
    </a>
  )
}
